export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Richiesta di supporto tecnico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["da"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chat"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiungi messaggio"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["File"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puoi caricare uno o più file. Dimensione massima del file - 10MB."])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Testo del messaggio"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia"])}
}